module.exports = __webpack_public_path__ + "img/idc_pic02.31af4ac1.png";